module.exports = require("core-js-pure/features/object/define-property");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/object/define-property.js
// module id = 345
// module chunks = 0